import { LBSubscriptionStatus } from "@/services/LBSubscriptionService";
import { LBSubscriptionToggle } from "../../lb-subscription/LBSubscriptionToggle";

interface NotificationsTabProps {
    subscriptionStatus: LBSubscriptionStatus;
    onToggle: (subscribed: boolean, reason?: string) => Promise<void>;
    isLoading: boolean;
}

export const NotificationsTab: React.FC<NotificationsTabProps> = ({ subscriptionStatus, onToggle, isLoading }) => {
    return (
        <div>
            <LBSubscriptionToggle subscriptionStatus={subscriptionStatus} onToggle={onToggle} isLoading={isLoading} />
        </div>
    );
};
